import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import Preloader from '../../user/Preloader';
import { API_URL, APP_URL, FILE_URL, NO_IMG } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import EditProfile from './AdminProfileEdit';
import axios from 'axios';
import { toast } from 'react-toastify';
import ChangePassword from './AdminChangePassword';
import LoadingDashboardContent from '../../components/LoadingDashboardContent';
import AdminEditProfile from './AdminProfileEdit';
import { useTokens } from '../../context/TokenContext';

const AdminProfile = () => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { pathname, search } = useLocation();
  const [formData, setFormData] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_URL}/admin/profile`, {
          headers: {
            'Authorization': `Bearer ${adminAuthToken}`,
          },
        });

        if (response.status === 200) {
          setFormData(response.data.user);
        }
      } catch (error) {
        toast.error('Failed to fetch user data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const userName = formData ? `${formData.first_name} ${formData.last_name}` : '';
  const userRole = formData ? formData.roles : '';
  const profilePicture = formData ? formData.profile_picture : '';

  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Edit Admin</h1>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Link to={`${APP_URL}admin/customer`}>
            <button type="button" className="btn btn-sm btn-outline-secondary rounded-0">
              <i className="bi bi-arrow-left me-2"></i> Back to List
            </button>
          </Link>
          <button type="submit" className="btn btn-primary ms-2 btn-dark rounded-0">Create</button>
        </div>
      </div>

      { loading ? <LoadingDashboardContent / > : (
      <div className="row g-4 pt-1">
        <div className="col-md-3 col-lg-3">
          <div className="card mb-4">
            <div className="row g-0 align-items-center p-2 row-cols-auto">
              <div>
                <img
                  src={profilePicture && profilePicture.trim() !== '' ? `${FILE_URL}${profilePicture}` : NO_IMG}
                  className="img-fluid rounded-circle ratio-1x1 img-thumbnail object-fit-cover"
                  alt="User Avatar"
                  style={{ width: 80, height: 80 }}
                />
              </div>
              <div>
                <div className="card-body">
                  <span className="small text-muted fwt-italic">Hello,</span>
                  <h6 className="text-muted m-0 p-0">{userName}</h6>
                  <span className="small text-info" style={{ 'fontSize': 12 }}>({userRole})</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <ul className="list-group list-group-flush">
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/profile`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-person"></i> Profile
                </Link>
              </li>
              <li className="list-group-item list-group-item-action">
                <Link to={`${APP_URL}admin/profile/change-password`} className="d-block text-dark text-decoration-none">
                  <i className="bi bi-fingerprint"></i> Security
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Main Content */}
        <div className="col-md-9 col-lg-9">
          <div className="card">
            <div className="card-body p-4">
              {loading ? (
                <Preloader />
              ) : (
                <>
                  <Routes>
                    {/* Default route that loads on initial visit */}
                    <Route index element={<AdminEditProfile userData={formData} setUserData={(data) => setFormData(prev => ({ ...prev, ...data }))} />} />
                    <Route path="profile" element={<AdminEditProfile userData={formData} setUserData={(data) => setFormData(prev => ({ ...prev, ...data }))} />} />
                    <Route path="change-password" element={<ChangePassword />} />
                  </Routes>

                  {/* This Outlet renders the nested route content */}
                  <Outlet />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default AdminProfile;
